<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column7">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column5">
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://hotelpoelkapelle.us22.list-manage.com/subscribe/post?u=3bf622d8bcf20a8a6c864e642&amp;id=f159ad4811&amp;f_id=0025cde1f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate"
						target="_blank"
					>
						<div id="mc_embed_signup_scroll">
							<div class="mc-field-group">
								<input
									id="mce-EMAIL"
									type="email"
									:placeholder="$t('formEmail')"
									name="EMAIL"
									class="required email"
									required=""
									value=""
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</div>
							<div id="mce-responses" class="clear foot">
								<div id="mce-error-response" class="response" style="display: none"></div>
								<div cid="mce-success-response" lass="response" style="display: none"></div>
							</div>
							<div aria-hidden="true" style="position: absolute; left: -5000px">
								<input
									type="text"
									name="b_3bf622d8bcf20a8a6c864e642_f159ad4811"
									tabindex="-1"
									value=""
								/>
							</div>
							<div class="optionalParent">
								<div class="clear foot"></div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: var(--dark-background-color);
	color: var(--body-color);

	h2,
	div {
		color: #fff;
	}

	form {
		padding: 35px;
		background: var(--button-color-hover);
		width: 100%;
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		align-items: center;

		> div {
			width: 100%;
		}

		input {
			background: var(--primary-background-color);
			padding: 15px;
			height: 52px;
			border: none;
			width: 60%;
			vertical-align: top;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				background: var(--cta-color);
				color: #fff;
				width: 38%;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}

@media (max-width: 1080px) {
	.column5 {
		width: 100%;
		max-width: 700px;
	}
}

@media (max-width: 480px) {
	.newsletter-section {
		form {
			input {
				width: 100%;

				&.button {
					width: 100%;
				}
			}
		}
	}
}
</style>
